/**
 * Backend API origin (scheme + host + port). No trailing slash.
 * - Leave unset locally (dev bundle): defaults to http://localhost:8081.
 * - Production bundle with unset: empty string → same-origin requests (Docker + Cloud Run).
 * - Override anytime: REACT_APP_BACKEND_SERVER_URI=https://api.example.com
 */
const raw = process.env.REACT_APP_BACKEND_SERVER_URI;

const trimmed =
  typeof raw === "string" && raw.trim().length > 0
    ? raw.trim().replace(/\/+$/, "")
    : null;

export const API_BASE = trimmed ?? "https://movieduel-remastered-195497636375.us-east1.run.app";